import { Mapper } from '@data/base/mapper';
import { CidadeEntity } from '@domain/dto/cidade/cidade-get.dto';
export class HomeMapper extends Mapper<CidadeEntity> {
  fromJson(param: any): CidadeEntity {
    return param;
  }
}
